import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import BuildingTableComponent from './BuildingTableComponent';

import { openDoor } from '../AccessPoint/actionCreators';
import {
  confirmBuildingDeletion,
  getBuildingsList,
  pinBuilding,
  unpinBuilding,
} from './actionCreators';

import { getTodayCount } from '../../utils';

import * as buildingSelectors from './selectors';

const LIST_KEY = 'buildingsList';

const BuildingTableContainer = (props) => {
  const { onGetBuildingsList, listParams, pinnedBuildings } = props;

  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetBuildingsList(queryParams);
  };

  const getIsPinnedBuilding = (id) =>
    !!pinnedBuildings.find(({ buildingId }) => buildingId === id);

  return (
    <BuildingTableComponent
      {...props}
      onExport={onExport}
      getIsPinnedBuilding={getIsPinnedBuilding}
    />
  );
};

BuildingTableContainer.propTypes = {
  onGetBuildingsList: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  pinnedBuildings: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { pmcs, buildingsList, common, lists } = state;
  const pmcId = ownProps?.match?.params?.PMCId;
  const pmc = pmcs?.[pmcId];
  const buildings = buildingsList ?? {};
  // refactor selectors
  const pinnedBuildings = buildingSelectors.getPinnedBuildings(state);
  return {
    user: common?.currentUser,
    listKey: LIST_KEY,
    listParams: lists?.[LIST_KEY] ?? {},
    items: buildings,
    pmcId,
    pmc,
    pinnedBuildings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getItems: (queryParams) => {
    getBuildingsList(dispatch, queryParams);
    getTodayCount(getBuildingsList, dispatch, queryParams);
  },
  onDelete: (building, queryParams) =>
    confirmBuildingDeletion(dispatch, building, queryParams),
  openDoor: (door) => openDoor(dispatch, door),
  onGetBuildingsList: (queryParams) =>
    getBuildingsList(dispatch, queryParams, true),
  pinBuilding: (buildingId, buildingName) =>
    pinBuilding(dispatch, buildingId, buildingName),
  unpinBuilding: (buildingId) => unpinBuilding(dispatch, buildingId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BuildingTableContainer);
